'use client';

import { useContext } from 'react';

import { cn } from '@natu/utils/cn';

import { CarouselContext } from './CarouselContext';

const CarouselGradient = () => {
  const ctx = useContext(CarouselContext);
  if (ctx === null) return null;

  const { scrollProgress } = ctx;

  const gradientClassName = cn(
    'from-background pointer-events-none absolute -right-px bottom-0 top-0 hidden w-48 bg-gradient-to-l to-transparent transition-opacity duration-500 2xl:block',
    scrollProgress < 0.9 ? 'opacity-100' : 'opacity-0',
  );

  return <div className={gradientClassName} />;
};

export { CarouselGradient };
